import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=42d8e131&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
import style0 from "../assets/css/help.css?vue&type=style&index=0&id=42d8e131&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d8e131",
  null
  
)

export default component.exports